import { z } from 'zod';

export const PermitsAttachmentsScalarFieldEnumSchema = z.enum(['id','city_id','permit_id','file_name','file_type','file_size','key','url','created_at','updated_at','external_id']);

export default PermitsAttachmentsScalarFieldEnumSchema;
